import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export const UnauthorizedPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-900">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-red-500 mb-4">403</h1>
        <h2 className="text-2xl font-semibold text-white mb-4">Erişim Reddedildi</h2>
        <p className="text-gray-400 mb-8">
          Bu sayfaya erişim yetkiniz bulunmamaktadır. Lütfen yönetici ile iletişime geçin.
        </p>
        <button
          onClick={() => navigate('/admin')}
          className="inline-flex items-center gap-2 px-6 py-3 bg-blue-500 text-white rounded font-medium hover:bg-blue-600 transition"
        >
          <ArrowLeft size={20} />
          Ana Sayfaya Dön
        </button>
      </div>
    </div>
  );
};
